"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeneralItem = exports.CategoryItem = exports.ActionItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _images = require("../../../assets/images");

var _style = require("./style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const GeneralItem = ({
  title,
  subtitle,
  imgUrl,
  imgAltText = 'item-img',
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_style.StyledItemGeneral, props, /*#__PURE__*/_react.default.createElement(_style.StyledThumbnail, null, imgUrl && /*#__PURE__*/_react.default.createElement("img", {
    src: imgUrl,
    alt: imgAltText
  })), /*#__PURE__*/_react.default.createElement(_style.StyledContent, null, /*#__PURE__*/_react.default.createElement(_style.StyledTitle, null, title), /*#__PURE__*/_react.default.createElement(_style.StyledSubtitle, null, subtitle)));
};

exports.GeneralItem = GeneralItem;
GeneralItem.propTypes = {
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string.isRequired,
  imgUrl: _propTypes.default.string.isRequired,
  imgAltText: _propTypes.default.string.isRequired
};

const ActionItem = ({
  title,
  subtitle,
  imgUrl,
  imgAltText,
  onItemClick,
  showArrow,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_style.StyledItemGeneral, _extends({}, props, {
    isActionItem: true
  }), /*#__PURE__*/_react.default.createElement(_style.StyledThumbnail, {
    isActionItem: true
  }, imgUrl && /*#__PURE__*/_react.default.createElement("img", {
    src: imgUrl,
    alt: imgAltText
  })), /*#__PURE__*/_react.default.createElement(_style.StyledContent, {
    isActionItem: true
  }, /*#__PURE__*/_react.default.createElement(_style.StyledTitle, null, typeof title === 'function' ? title() : title), /*#__PURE__*/_react.default.createElement(_style.StyledSubtitle, null, subtitle)), showArrow && /*#__PURE__*/_react.default.createElement(_style.StyledArrow, {
    onClick: () => onItemClick({
      title,
      subtitle,
      imgUrl,
      imgAltText
    })
  }, /*#__PURE__*/_react.default.createElement(_images.RightArrow, null)));
};

exports.ActionItem = ActionItem;
ActionItem.defaultProps = {
  showArrow: true
};
ActionItem.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]).isRequired,
  subtitle: _propTypes.default.string.isRequired,
  imgUrl: _propTypes.default.string.isRequired,
  imgAltText: _propTypes.default.string.isRequired,
  onItemClick: _propTypes.default.func,
  showArrow: _propTypes.default.bool
};

const CategoryItem = ({
  label,
  value,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_style.StyledCategoryItem, props, /*#__PURE__*/_react.default.createElement(_style.StyledText, null, label), /*#__PURE__*/_react.default.createElement(_style.StyledValue, null, value));
};

exports.CategoryItem = CategoryItem;
CategoryItem.propTypes = {
  label: _propTypes.default.string,
  value: _propTypes.default.string
};